// Marketing / attribution SDK loaders — invoked ONLY after advertisement consent
// (see App.js → onConsent). Ported from the inline Meta Pixel snippet that used
// to live in public/index.html and from public/js/appsflyer-pba.js. We load them
// from JS on consent instead of unconditionally in <head>, so nothing fires or
// stores anything until the user accepts. Both loaders are idempotent.

export const META_PIXEL_ID = "1779992652909623";
export const APPSFLYER_WEB_KEY = "3a20fc8c-cadd-4d3f-b31c-6b5c9c650e31";

/** Meta Pixel — loads fbevents.js, writes _fbp / _fbc, fires a PageView. */
export function loadMetaPixel(pixelId = META_PIXEL_ID) {
  if (!pixelId || typeof window === "undefined" || window.fbq) return;
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
}

/** AppsFlyer PBA Web SDK — loads the SDK, writes afUserId. */
export function loadAppsFlyer(webDevKey = APPSFLYER_WEB_KEY) {
  if (!webDevKey || typeof window === "undefined" || (window.AF && window.AF.plugins)) return;
  (function (webDevKey) {
    (function (window, document, tagName, s, AFobjectName, pluginName) {
      window.AppsFlyerSdkObject = AFobjectName;
      window.AF =
        window.AF ||
        function () {
          (window.AF.q = window.AF.q || []).push(
            [Date.now()].concat(Array.prototype.slice.call(arguments)),
          );
        };
      window.AF.id = window.AF.id || pluginName;
      window.AF.plugins = {};
      var scriptEl = document.createElement(tagName);
      var firstScript = document.getElementsByTagName(tagName)[0];
      scriptEl.async = true;
      scriptEl.src = "https://websdk.appsflyer.com?st=pba&af_id=" + pluginName;
      firstScript.parentNode.insertBefore(scriptEl, firstScript);
    })(window, document, "script", 0, "AF", webDevKey);
  })(webDevKey);
}
